import React__default from 'react';
import Memo from './add-new.svg.js';
import Memo$1 from './approval.svg.js';
import Memo$2 from './authorization.svg.js';
import Memo$3 from './borrowing-base.svg.js';
import Memo$4 from './branch.svg.js';
import Memo$5 from './budget.svg.js';
import Memo$6 from './comments.svg.js';
import Memo$7 from './commercial.svg.js';
import Memo$8 from './contacts.svg.js';
import Memo$9 from './contractor-review.svg.js';
import Memo$a from './document-expiring.svg.js';
import Memo$b from './draws.svg.js';
import Memo$c from './files.svg.js';
import Memo$d from './flood.svg.js';
import Memo$e from './funding-sources.svg.js';
import Memo$f from './in-progress.svg.js';
import Memo$g from './inspections.svg.js';
import Memo$h from './line-of-credit.svg.js';
import Memo$i from './lot.svg.js';
import Memo$j from './milestones.svg.js';
import Memo$k from './notifications.svg.js';
import Memo$l from './overview.svg.js';
import Memo$m from './pending-transfer.svg.js';
import Memo$n from './projects.svg.js';
import Memo$o from './residential.svg.js';
import Memo$p from './search-no-results.svg.js';
import Memo$q from './search.svg.js';
import Memo$r from './subdivisions.svg.js';
import Memo$s from './sublimits.svg.js';
import Memo$t from './templates.svg.js';
import Memo$u from './units.svg.js';

const BuiltSVG = {
    'add-new': React__default.createElement(Memo, null),
    approval: React__default.createElement(Memo$1, null),
    authorization: React__default.createElement(Memo$2, null),
    'borrowing-base': React__default.createElement(Memo$3, null),
    branch: React__default.createElement(Memo$4, null),
    budget: React__default.createElement(Memo$5, null),
    comments: React__default.createElement(Memo$6, null),
    commercial: React__default.createElement(Memo$7, null),
    contacts: React__default.createElement(Memo$8, null),
    'contractor-review': React__default.createElement(Memo$9, null),
    'document-expiring': React__default.createElement(Memo$a, null),
    draws: React__default.createElement(Memo$b, null),
    files: React__default.createElement(Memo$c, null),
    flood: React__default.createElement(Memo$d, null),
    'funding-sources': React__default.createElement(Memo$e, null),
    'in-progress': React__default.createElement(Memo$f, null),
    inspections: React__default.createElement(Memo$g, null),
    'line-of-credit': React__default.createElement(Memo$h, null),
    lot: React__default.createElement(Memo$i, null),
    milestones: React__default.createElement(Memo$j, null),
    notifications: React__default.createElement(Memo$k, null),
    overview: React__default.createElement(Memo$l, null),
    'pending-transfer': React__default.createElement(Memo$m, null),
    projects: React__default.createElement(Memo$n, null),
    residential: React__default.createElement(Memo$o, null),
    'search-no-results': React__default.createElement(Memo$p, null),
    search: React__default.createElement(Memo$q, null),
    subdivisions: React__default.createElement(Memo$r, null),
    sublimits: React__default.createElement(Memo$s, null),
    templates: React__default.createElement(Memo$t, null),
    units: React__default.createElement(Memo$u, null),
};

export { BuiltSVG };
//# sourceMappingURL=index.js.map
